<template>
    <LegalDocument document="privacy" />
</template>

<script>
import LegalDocument from './LegalDocument.vue'

export default {
    components: { LegalDocument }
}
</script>
